import { render } from "./PromotionMain.vue?vue&type=template&id=7615f3d8&scoped=true"
import script from "./PromotionMain.vue?vue&type=script&lang=js"
export * from "./PromotionMain.vue?vue&type=script&lang=js"

import "./PromotionMain.vue?vue&type=style&index=0&id=7615f3d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7615f3d8"]])

export default __exports__